<script lang="ts" setup>
import { button } from "./button.variant";
import { useAttrs } from "vue";

const attrs = useAttrs();

type ButtonProps = {
  size?: "small" | "medium";
  variant?: "default" | "outlined";
  color?: "primary" | "secondary" | "nocolor";
  mode?: "light" | "dark";
  rounded?: boolean;
};

const {
  size = "medium",
  variant = "default",
  mode = "light",
  color = "primary",
  rounded = false,
} = defineProps<ButtonProps>();
</script>
<template>
  <button
    v-focus
    :class="button({ size, variant, mode, color, rounded })"
    v-bind="attrs"
  >
    <slot name="iconLeft"></slot>
    <slot></slot>
    <slot name="iconRight"></slot>
  </button>
</template>
